"use client";

import { usePathname } from "next/navigation";
import { getStudyCategory } from "@/lib/route-layout";
import { usePageVisit } from "@/hooks/usePageVisit";

/**
 * 이론/코딩 학습 페이지 방문을 기록해 "과목 마스터" 배지를 수여하는 트래커 (JCG-2262).
 *
 * LayoutContent globals 에 한 번 마운트돼 셸/클래식 모든 분기에서 상주한다(UI 없음, null 반환).
 * `getStudyCategory`(= `isArticlePage` 구조 검증)로 **이론/코딩 본문 글만** 통과시켜 인덱스·공부계획
 * 페이지의 불필요한 서버 호출을 막는다(StudyVisitTracker와 동일 게이트). dedup·3초 dwell은 `usePageVisit`,
 * 과목 콘텐츠 최종 판정·배지 수여는 서버 `recordPageVisit`(트랜잭션)이 담당.
 */
export default function PageVisitTracker() {
  const pathname = usePathname();
  const category = pathname ? getStudyCategory(pathname) : null;
  // 이론/코딩 본문 글만 추적. 그 외엔 빈 경로로 no-op.
  const trackable = category === "theory" || category === "coding";
  usePageVisit(trackable && pathname ? pathname : "");
  return null;
}
